"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import YoutubeChannelCard from "@/components/card/youtube-channel";
import HomeSection from "@/components/home-section";

function YoutubeChannels({ channels }) {
  return (
    <HomeSection
      title="Youtube Channels"
      subtitle={
        <>
          <span>Catch Us</span>
          <span className="text-primary">Live on Youtube</span>
        </>
      }
      className="block"
    >
      <Swiper
        modules={[Autoplay]}
        slidesPerView={1.9}
        spaceBetween={16}
        breakpoints={{
          560: {
            slidesPerView: 3,
          },
        }}
        autoplay={{
          delay: 3000,
          pauseOnMouseEnter: true,
        }}
        loop
      >
        {channels.map((channel) => (
          <SwiperSlide key={channel.title}>
            <YoutubeChannelCard
              title={channel.title}
              subscribersCount={channel.subscribers}
              variant={channel.variant.toLowerCase()}
              channelLink={channel.channelLink}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </HomeSection>
  );
}

export default YoutubeChannels;
